import { render, staticRenderFns } from "./browser-banner.vue?vue&type=template&id=1030b00b"
var script = {}
import style0 from "./browser-banner.vue?vue&type=style&index=0&id=1030b00b&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports